import { useEffect, useContext, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "./navBar.css";
import { SpinnerContext } from "../../context/spinnerContext";
import { SpinnerContextType } from "../../types/types";
import waitAllImagesCharged from "../../utils/waitAllImagesCharged";
import { HashLink } from "react-router-hash-link";
import { scrollWithoffset } from "../../utils/functions";

const NavBar = () => {
    
    const { showSpinner } = useContext <SpinnerContextType> (SpinnerContext);
    const thisLocation = useLocation ();
    const  intervalId = useRef <number | NodeJS.Timeout> (0);
        
    useEffect(() => {   

        /****************************************** OoS ************************************************/

        const OoS = () => {
            const OoSElements: NodeListOf<HTMLElement> = document.querySelectorAll(".OoS");
            const OoSElementsWf: NodeListOf<HTMLElement> = document.querySelectorAll(".OoSwF");
            OoSElements.forEach((element) => {          //Mostramos el elemento cuando aparece su primer mitad
                if(((element.getBoundingClientRect().top ) <= (window.innerHeight  - (element.offsetHeight / 2)))) element.classList.add("OoSS");   
            });
            OoSElementsWf.forEach((element) => {          //Mostramos el elemento cuando aparece su primer mitad
                if(((element.getBoundingClientRect().top ) <= (window.innerHeight  - (element.offsetHeight / 2)))) element.classList.add("OoSwFF");   
            });
        };
        window.addEventListener("resize", OoS);
        window.addEventListener("orientationchange", OoS);
        window.addEventListener("scroll", OoS);
        OoS();

        let tempo: NodeJS.Timeout;     //Si estamos 1 segundo sin hacer scroll y hay alguna parte de un elemento OoS visible lo mostramos
        const handleTempo = () => {     //Se borra el temporizador actual y se crea un nuevo cada vez que hacemos scroll
            clearTimeout(tempo);  
            tempo = setTimeout(() => {
                const OoSElements = document.querySelectorAll(".OoS");
                const OoSElementsWf = document.querySelectorAll(".OoSwF");
                OoSElements.forEach((element) => {
                    if(((element.getBoundingClientRect().top) < (window.innerHeight))) element.classList.add("OoSS");
                });
                OoSElementsWf.forEach((element) => {
                    if(((element.getBoundingClientRect().top) < (window.innerHeight))) element.classList.add("OoSwFF");
                });
            }, 1000);
        };
        window.addEventListener("resize", handleTempo);
        window.addEventListener("orientationchange", handleTempo);
        window.addEventListener("scroll", handleTempo);
        handleTempo();


        /*********************************************************************************************************/
        //Espera que se carguen todas las imágenes en la pagina actual si esta tiene la clase "seccionToWaitImages"
                 
        const checkImages = async () => {
            const componentToWaitImages: HTMLElement | null = document.querySelector(".seccionToWaitImages");
            if (componentToWaitImages) {
                const animations = componentToWaitImages.getAnimations({ subtree: true });
                animations.forEach((animation) => {                                 //Pausamos las animaciones
                    animation.pause();
                });
                componentToWaitImages.classList.add("opacity0");
                
                showSpinner(true);
                await waitAllImagesCharged();
                showSpinner(false);

                componentToWaitImages.classList.add("opacityOnCharge");
                animations.forEach((animation) => {                                 //Reanudamos las animaciones
                    animation.play();
                });
            }
        };
        checkImages();
       
        /*** Al cambiar de pagina el scroll se va arriba ***/
        window.scrollTo({top: 0}); 
        /***************************************************/
        // eslint-disable-next-line
    }, [thisLocation])
       
    /**********************************************************************************************/
            
    useEffect(() => {

        const iconoMenu = document.querySelector(".iconoMenu");
        iconoMenu?.setAttribute("name", "iconoMenu");
        const menu = document.querySelector(".menu") as HTMLDivElement;
        menu?.setAttribute("name", "menu");
        const opciones = document.getElementsByClassName("opcion");
        let initialWidth = window.innerWidth;
        let REM: number;
        let breakPoint = 0;
        let menuBajo = false;
        let flagEnterMenuToggle = true;
        iconoMenu?.addEventListener("click", () => {                         //Manejo de clases para bajar y subir menu
            if (flagEnterMenuToggle) {
                flagEnterMenuToggle = false;
                if (!menuBajo) {
                    menu?.classList.remove("menuSube", "menuBaja");
                    menu?.classList.add("menuBaja");
                    menuBajo = !menuBajo;    
                    const animations = menu?.getAnimations() as Animation[];
                    animations[0].addEventListener("finish", () => {
                        flagEnterMenuToggle = true;
                    });
                } else {
                    menu?.classList.remove("menuBaja", "menuSube");
                    menu?.classList.add("menuSube");
                    menuBajo = !menuBajo;  
                    const animations = menu?.getAnimations() as Animation[];
                    animations[0].addEventListener("finish", () => {
                        flagEnterMenuToggle = true;
                    });
                }
            }
        });

        const calcularREM = () => {
            if (window.innerWidth >= window.innerHeight) REM = 0.01 * window.innerHeight + 10;
            if (window.innerWidth < window.innerHeight) REM = 0.01 * window.innerWidth + 10;
            breakPoint = 60 * REM;
        };
         
        calcularREM();
        if(window.innerWidth < breakPoint) {                                        //Cargamos página con un ancho menor a BreakPoint
            const userAuthenticationComponent = document.querySelector(".userAuthenticationCont");
            menu?.classList.add("iconoMenuON", "menuOFF");
            iconoMenu?.classList.add("iconoMenuON");
            for (const opcion of opciones) {
                opcion.classList.add("opcion2");
            }
            userAuthenticationComponent?.classList.add("userAuthenticationContCenter");
        }
        
        const check = () => {
            const userAuthenticationComponent = document.querySelector(".userAuthenticationCont");
            calcularREM();           
            if(initialWidth <= breakPoint && window.innerWidth > breakPoint) {                   //Pasamos de un ancho de pantalla menor a breakPoint a uno mayor
                menu?.classList.remove("menuSube", "menuBaja", "menuOFF");
                iconoMenu?.classList.remove("iconoMenuON");
                for (const opcion of opciones) {
                    opcion.classList.remove("opcion2");
                }
                menuBajo = false;
                initialWidth = window.innerWidth;
                userAuthenticationComponent?.classList.remove("userAuthenticationContCenter");
            }     
            if(initialWidth > breakPoint && window.innerWidth < breakPoint) {                   //Pasamos de un ancho de pantalla mayor a breakPoint a uno menor
                menu?.classList.add("menuOFF");
                iconoMenu?.classList.add("iconoMenuON");
                for (const opcion of opciones) {
                    opcion.classList.add("opcion2");
                }
                initialWidth = window.innerWidth;
                userAuthenticationComponent?.classList.add("userAuthenticationContCenter");
            }     
        };        

        window.addEventListener("resize", () => check());                                        //Manejo de clases al hacer resize o cambio de orientacion
        check();

        window.addEventListener("click", (e) => {                                               //Cerramos en menu desplegado al hacer click en cualquier lado menos en el icono de menu
            const sameElement = e.target as HTMLElement;
            if (sameElement.getAttribute("name") !== "iconoMenu" && menuBajo === true) {
                menu?.classList.remove("menuBaja", "menuSube");
                menuBajo = false;
            }
        });

        /******************************************* Seteo del ancho del menu segun orientacion y ancho de patalla *****************************************/

        const handleMenuStyle = () => {
            const scrollWidth = window.innerWidth - document.body.offsetWidth;
            const contMenu = document.querySelector(".contMenu") as HTMLDivElement;   
            if (scrollWidth > 0 &&  window.innerWidth > window.innerHeight) {      //Pantalla de pc o de celu acostado 
                contMenu.style.width = ((window.innerWidth - scrollWidth) * 0.8) + "px"; 
            } else if (window.innerWidth > window.innerHeight && window.innerWidth < 1200) {
                contMenu.style.width = ((window.innerWidth - scrollWidth) * 0.75) + "px"; 
            }  else {
                contMenu.style.width = "100%";                                                                  //Pantalla tactil (sin scroll) 
            }
        };
                        
        window.addEventListener("orientationchange", handleMenuStyle);
        window.addEventListener("resize", handleMenuStyle);
        handleMenuStyle();
        // eslint-disable-next-line
    }, []);    

    /***************************************** Cambia el color de la opcion del navbar elegida y luego al hacer scroll le saca el color ************************************/

    const clearNavBarOptions = useRef(()=> {
        const navBarOptions = document.querySelectorAll(".opcion");
        for (const option of navBarOptions) {
            option.classList.remove("navBarOptionColorOn");
        }
        window.removeEventListener("scroll", clearNavBarOptions.current);
    });

    const setNavBaOption = (e: React.MouseEvent) => {
        clearInterval(intervalId.current);
        window.removeEventListener("scroll", clearNavBarOptions.current);

        const navBarOptions = document.querySelectorAll(".opcion");
        for (const option of navBarOptions) {
            option.classList.remove("navBarOptionColorOn");
        }
        const optionSetect = e.target as HTMLAnchorElement;
        optionSetect.classList.add("navBarOptionColorOn");
       
        let prevScrollY = window.scrollY;
        intervalId.current = setInterval(() => {                                    //Cada 50 ms verifica si se está haciendo scroll

            if (window.scrollY === prevScrollY) {
                window.addEventListener("scroll", clearNavBarOptions.current);  
                clearInterval(intervalId.current);
            } else {
                prevScrollY = window.scrollY;
            }
                        
        }, 50);
    };
    
    return (
        <div className="contMenu flex opacityOnCharge">
            <div className="navBarContLogoEidioma flex">
                <Link to="/" className="navBarContLogo flex"><img src="/images/logo2.png" alt="Logo Tropicalia" className="navBarLogo" /></Link>
            </div>
            <img className="iconoMenu" src="/images/icons/menu.png" alt="Icono Menu"/>
            <div className="tapaMenu"></div>
            <div className="menu flex">
                <HashLink className="opcion navBarOptionColorOn flex" to="/#home" scroll={(e) => scrollWithoffset(e)} onClick={setNavBaOption}>Home</HashLink>
                <HashLink className="opcion flex" to="/#nosotros" scroll={(e) => scrollWithoffset(e)} onClick={setNavBaOption}>Nosotros</HashLink>
                <HashLink className="opcion flex" to="/#servicios" scroll={(e) => scrollWithoffset(e)} onClick={setNavBaOption}>Servicios</HashLink>
                <HashLink className="opcion flex" to="/#contacto" scroll={(e) => scrollWithoffset(e)} onClick={setNavBaOption}>Contacto</HashLink>
            </div>
        </div>
    );  
};   

export default NavBar;
